export const headers = [
  { field: "id", headerName: "ID", width: 45, hidden: true },
  { field: "sel_firstname", headerName: "Nombre", width: 230 },
  { field: "sel_lastname", headerName: "Apellido", width: 230 },
  { field: "descripcionRol", headerName: "Rol", width: 140 },
  ];
  